import {getAuth, signInWithEmailAndPassword, signOut} from 'firebase/auth'
import React, {useState} from 'react'
import {Box} from './Box'
import {Button} from './Button'
import {TextField, TextFieldProps} from './inputs/TextField'
import {LoadingSpinnerContainer} from './progress/LoadingSpinnerContainer'

interface LoginDrawerProps {}

export const LoginForm: React.FC<LoginDrawerProps> = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const onChangeEmail: TextFieldProps['onChange'] = (value) => {
    setEmail(value)
  }

  const onChangePassword: TextFieldProps['onChange'] = (value) => {
    setPassword(value)
  }

  const onLogin = async () => {
    setErrorMessage('')
    setLoading(true)
    try {
      await signInWithEmailAndPassword(getAuth(), email, password)
    } catch (e) {
      setErrorMessage('Something went wrong. Try to log in again or use another email.')
      await signOut(getAuth())
    }

    setLoading(false)
  }

  return (
    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100vh'}>
      <form
        style={{
          flexDirection: 'column',
          display: 'flex',
          margin: 2,
          padding: 16,
          border: '#eaeaea 1px solid',
          borderRadius: 5,
        }}
        onSubmit={(e) => {
          e.preventDefault()
          onLogin()
        }}
      >
        <TextField id="login-email" label="Email" value={email} onChange={onChangeEmail} helperText={errorMessage} error={Boolean(errorMessage)} />
        <TextField id="login-password" label="Password" value={password} onChange={onChangePassword} type={'password'} />
        {loading ? (
          <LoadingSpinnerContainer />
        ) : (
          <Button type="submit" sx={{marginTop: 16}} onClick={onLogin}>
            Login
          </Button>
        )}
      </form>
    </Box>
  )
}
